// extracted by mini-css-extract-plugin
export var boxItems = "_6o-1";
export var boxItemsLg = "_6o-2";
export var button = "_6o-7";
export var buttonHoverless = "_6o-9";
export var buttonLg = "_6o-8";
export var filterGroupBox = "_6o-0";
export var icon = "_6o-3";
export var iconSecondary = "_6o-6";
export var iconWrapper = "_6o-4";
export var iconWrapperLg = "_6o-5";
export var truncatedLabel = "_6o-a";